// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2Eo-t","colMin":"styles_colMin__3w0Ny","colCheckbox":"styles_colCheckbox__3MWBx"};